import React from 'react'
import AboutUs from '../About-us/AboutUs'
import OurPromises from '../OurPromises/OurPromises'
import TeamWork from '../TeamWork/TeamWork'
import Application from '../Application/Application'
import Trusted from '../Trusted/Trusted'
import Newsletter from '../Newsletter/Newsletter'

const AboutUsPage = () => {
  return (
    <div>
      <AboutUs />
      <OurPromises />
      <TeamWork />
      <Application />
      <Trusted />
      <Newsletter />
    </div>
  )
}

export default AboutUsPage
